import { useLocalization as e } from "./localization/index.js";
import { formatValue as t } from "./helpers/format-value.js";
import { createCommentVNode as n, createElementBlock as r, createElementVNode as i, createVNode as a, defineComponent as o, normalizeClass as s, openBlock as c, ref as l, toDisplayString as u, unref as d, useId as f } from "vue";
import { ScalarIcon as p } from "@scalar/components/icon";
import { useClipboard as m } from "@scalar/use-hooks/useClipboard";
import { onClickOutside as h, onKeyStroke as g } from "@vueuse/core";
//#region src/schema/SchemaPropertyDefault.vue?vue&type=script&setup=true&lang.ts
var _ = ["aria-controls", "aria-expanded"], v = ["id"], y = ["aria-label"], b = 500, x = /*@__PURE__*/ o({
	__name: "SchemaPropertyDefault",
	props: { value: {} },
	setup(o) {
		let { copyToClipboard: x } = m(), { translate: S } = e(), C = l(null), w = l(null), T = l(!1), E = f(), D = () => {
			T.value = !T.value;
		}, O = () => {
			!A && !k && (T.value = !0);
		}, k = !1, A = !1, j = 0, M = () => {
			A = !0, window.clearTimeout(j), j = window.setTimeout(() => {
				A = !1;
			}, b);
		}, N = (e) => {
			let t = e.relatedTarget;
			(!(t instanceof Node) || !C.value?.contains(t)) && (T.value = !1);
		}, P = () => {
			let e = C.value?.contains(document.activeElement);
			T.value = !1, e && (k = !0, w.value?.focus(), k = !1);
		};
		return h(C, P), g("Escape", () => {
			T.value && P();
		}), (e, l) => o.value === void 0 ? n("", !0) : (c(), r("div", {
			key: 0,
			ref_key: "rootRef",
			ref: C,
			class: s(["property-default", { "is-open": T.value }]),
			onFocusin: O,
			onFocusout: N
		}, [i("button", {
			ref_key: "labelRef",
			ref: w,
			"aria-controls": d(E),
			"aria-expanded": T.value,
			class: "property-default-label",
			type: "button",
			onClick: D,
			onPointerdown: M
		}, [i("span", null, u(d(S)("schema.default")), 1)], 40, _), i("div", {
			id: d(E),
			class: s(["property-default-value-list", { "flex!": T.value }])
		}, [i("button", {
			"aria-label": `${d(S)("common.copyDefault")}: ${d(t)(o.value)}`,
			class: "property-default-value group",
			type: "button",
			onClick: l[0] ||= (e) => d(x)(d(t)(o.value))
		}, [i("span", null, u(d(t)(o.value)), 1), a(d(p), {
			"aria-hidden": "true",
			class: "group-hover:text-c-1 text-c-3 ml-auto min-h-3 min-w-3",
			icon: "Clipboard",
			size: "xs"
		})], 8, y)], 10, v)], 34));
	}
});
//#endregion
export { x as default };

//# sourceMappingURL=SchemaPropertyDefault.vue.script.js.map